import { Breadcrumb } from "@/components/ui";
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/warehouse/source-tables")({
  component: () => (
    <Breadcrumb label="Source Tables" to="/warehouse/source-tables">
      <Outlet />
    </Breadcrumb>
  ),
});
